// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ijQVz","image":"styles_image__X5Gj6","input":"styles_input__lwoD4","radioButton":"styles_radioButton__z64p2"};